import RestResource from '../rest.service';
import Service from '../api.service';

export default class DeliveryNoteTypesService extends RestResource {
  constructor() {
    super('delivery-note-types');
  }
}
